/** 引导消息属于当前任务，不新建计费、摘要、删除或结果卡片的轮次边界。 */
export function isConversationTurnStart(message: { type: string; metadata?: Record<string, unknown> }): boolean {
  return message.type === 'user' && message.metadata?.steered !== true && !message.metadata?.parentToolUseId;
}

/**
 * 从已排序消息中选择完整问答轮次；user 消息作为边界，前置 system 消息保留。
 * @param messages 按持久序号排列的消息骨架，不负责排序或鉴权。
 * @param turnUserMessageIds 所选 user 消息 ID；assistant/未知 ID 自动忽略。
 */
export function selectedConversationMessageIds(
  messages: ReadonlyArray<{ id: string; type: string; metadata?: Record<string, unknown> }>,
  turnUserMessageIds: readonly string[],
): string[] {
  const requested = new Set(turnUserMessageIds);
  const deleted: string[] = [];
  let selected = false;
  for (const message of messages) {
    if (isConversationTurnStart(message)) selected = requested.has(message.id);
    if (selected) deleted.push(message.id);
  }
  return deleted;
}
